import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil, withLatestFrom} from "rxjs";
import {Store} from "@ngrx/store";
import {TranslateService} from "@mangosoft/mango-layout";
import {AccessControlService} from "../../../infrastructure/services/access-control.service";
import {
  selectLoadingBulkActionButton,
  selectSelectedProcessResults
} from "../../../infrastructure/store/process-result/process-result.selector";
import {selectSelectedProcess} from "../../../infrastructure/store/process/process.selector";
import {ProcessI} from "../../../infrastructure/interfaces/process.interface";
import {ActionButton, ProcessResultI} from "../../../infrastructure/interfaces/process-result.interface";
import {
  dispatchBulkActionButton,
  setLoadingActionButton,
  setLoadingBulkActionButton
} from "../../../infrastructure/store/process-result/process-result.actions";

@Component({
  selector: 'app-actions-buttons-bulk-action',
  templateUrl: './actions-buttons-bulk-action.component.html',
  styleUrls: ['./actions-buttons-bulk-action.component.scss']
})
export class ActionsButtonsBulkActionComponent implements OnInit ,OnDestroy {
  destroy$ = new Subject<void>();

  language!: any;

  process: ProcessI | null = null;

  selectedProcessResults: ProcessResultI[] = [];

  sections: {"section": string, buttons: ActionButton[]}[] = [];

  loadingBulkActionButton: string = "";

  constructor(
    private store: Store<any>,
    private translateService: TranslateService,
    private accessControlService: AccessControlService,
  ) {
    this.translateService
      .init("process-manager")
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.language = data;
      });
  }

  ngOnInit() {
    this.store.select(selectLoadingBulkActionButton).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.loadingBulkActionButton = value;
    })

    this.store.select(selectSelectedProcessResults).pipe(
      takeUntil(this.destroy$),
      withLatestFrom(this.store.select(selectSelectedProcess))
    ).subscribe(([values, process]) => {
      this.process = process;
      this.selectedProcessResults = values;

      const commonActionButtons = this.findCommonActionButtons(
        this.selectedProcessResults.map(item => item.action_buttons || [])
      );

      this.sections = this.getActionButtonsSections(commonActionButtons);
      console.log("Common =>", commonActionButtons)
      console.log("Sections =>", this.sections)

    });

  }

  findCommonActionButtons(actionButtonArray: ActionButton[][]): ActionButton[] {
    if (this.selectedProcessResults.length === 0) return [];

    return actionButtonArray.reduce((common: ActionButton[], current: ActionButton[]) => {
      const currentIds = new Set(current.map((item: ActionButton) => item.id));
      return common.filter((item: ActionButton) => currentIds.has(item.id));
    });
  }

  getActionButtonsSections(commonButtons: ActionButton[]): {"section": string, buttons: ActionButton[]}[] {
    if (commonButtons.length > 0) {
      const sections = commonButtons.reduce((acc: {[key:string]: ActionButton[]}, curr: ActionButton) => {
        if (Object.keys(acc).includes(curr.section)) {
          acc[curr.section].push(curr);
        }else{
          acc[curr.section] = [curr];
        }
        return acc;
      }, {
        "": []
      })

      return Object.keys(sections).reduce((acc: {"section": string, buttons: ActionButton[]}[], curr: string) => {
        acc.push({
          section: curr,
          buttons: sections[curr]
        })
        return acc;
      }, [])

    }
    return [];
  }


  dispatchActionButton(buttonId: string) {
    if (!this.loadingBulkActionButton) {
      if (this.process?.id && this.selectedProcessResults.length > 0){
        this.store.dispatch(setLoadingBulkActionButton({
          button: buttonId
        }))

        this.store.dispatch(dispatchBulkActionButton({
          processId: this.process.id,
          processResultIds: this.selectedProcessResults.map(item => item.id),
          buttonId: buttonId,
          all: false
        }))
      }
    }
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
